import get from 'lodash/get'
import { AppState } from 'state'
import { PairDataTimeWindowEnum } from './types'

type pairByDataIdSelectorParams = {
  pairId: string
  timeWindow: PairDataTimeWindowEnum
}

export const pairByDataIdSelector =
  ({ pairId, timeWindow }: pairByDataIdSelectorParams) =>
  (state: AppState) =>
    get(state, ['swap', 'pairDataById', pairId, timeWindow])

export const derivedPairByDataIdSelector =
  ({ pairId, timeWindow }: pairByDataIdSelectorParams) =>
  (state: AppState) =>
    get(state, ['swap', 'derivedPairDataById', pairId, timeWindow])

export const derivedPairByDataIdSelectorDB = (token: string, timeWindow: PairDataTimeWindowEnum) => (state: AppState) =>
  get(state, ['swap', 'derivedPairDataByIdDB', token, timeWindow])
